/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeRangeDto
 */
export interface TimeRangeDto {
    /**
     * 
     * @type {string}
     * @memberof TimeRangeDto
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof TimeRangeDto
     */
    endTime: string;
    /**
     * 
     * @type {boolean}
     * @memberof TimeRangeDto
     */
    endsOnNextDay: boolean;
}

/**
 * Check if a given object implements the TimeRangeDto interface.
 */
export function instanceOfTimeRangeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "startTime" in value;
    isInstance = isInstance && "endTime" in value;
    isInstance = isInstance && "endsOnNextDay" in value;

    return isInstance;
}

export function TimeRangeDtoFromJSON(json: any): TimeRangeDto {
    return TimeRangeDtoFromJSONTyped(json, false);
}

export function TimeRangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeRangeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'endsOnNextDay': json['endsOnNextDay'],
    };
}

export function TimeRangeDtoToJSON(value?: TimeRangeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startTime': value.startTime,
        'endTime': value.endTime,
        'endsOnNextDay': value.endsOnNextDay,
    };
}

